import request from '@/utils/request'
import { IAvmData, IAvmDataSubmit, IOrderData } from './types'

const BASE_ROUTE = 'api/v1/inspection/'
const FLOORPLAN_ROUTE = 'api/v1/floorplan/'
const PRINT_ROUTE = 'api/v1/print/'
const DOCUMENT_ROUTE = 'api/v1/document/'

export const assignInspector = (data: any) =>
  request({
    url: BASE_ROUTE + `${data.orderId}/assign`,
    method: 'post',
    data
  })

export const assignVendor = (data: any) =>
  request({
    url: BASE_ROUTE + `${data.orderId}/assign-vendor`,
    method: 'post',
    data
  })

export const getDashboard = () =>
  request({
    url: BASE_ROUTE + 'dashboard',
    method: 'get'
  })

export const getOrders = async(filter: string, searchValue: string) : Promise<IOrderData[]> => {
  let url: string = BASE_ROUTE + `list/${filter}`
  if (searchValue) {
    url += `/${searchValue}`
  }
  const response = await request({
    url: url,
    method: 'get'
  })
  return response.data
}

export const getOrder = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}`,
    method: 'get'
  })

export const getOrderHistory = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}/history`,
    method: 'post'
  })

export const getOrderViewReport = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}`,
    method: 'get'
  })

export const getOrderJsonResponse = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}/json-response`,
    method: 'get',
    responseType: 'blob'
  })

export const getOrderQAReport = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}/QA`,
    method: 'get'
  })

export const getOrderFreddieMacReport = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}/freddie-mac`,
    method: 'get'
  })

export const downloadFreddieMacJson = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}/freddie-mac-json`,
    method: 'get'
  })

export const downloadPdfReport = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}/pdf`,
    method: 'get',
    responseType: 'blob'
  })

export const eligibilityReport = (id: number, generateMe: boolean) =>
  request({
    url: PRINT_ROUTE + `${id}/eligibility${(generateMe ? '/generate' : '')}`,
    method: 'get',
    responseType: 'blob'
  })

export const regenerateReport = (id: number, options? : {timeout?: number}) =>
  request({
    url: PRINT_ROUTE + `${id}/generate`,
    method: 'get',
    responseType: 'blob',
    timeout: options?.timeout || 120000 // Default timeout of 2 minutes
  })

export const downloadXmlReport = (id: number) =>
  request({
    url: PRINT_ROUTE + `${id}/xml`,
    method: 'get',
    responseType: 'blob'
  })

export const createOrder = async(data: any): Promise<IOrderData> => {
  request({
    url: BASE_ROUTE + 'create',
    method: 'post',
    data
  })
  return data
}

export const adminUpdate = async(id: number, data: any): Promise<IOrderData> => {
  const response = await request({
    url: BASE_ROUTE + `${id}/admin-update/4`,
    method: 'post',
    data
  })
  return response.data
}
export const avmUpdate = async(id: number, data: IOrderData | null): Promise<IOrderData> => {
  const response = await request({
    url: BASE_ROUTE + `${id}/avm/update`,
    method: 'post',
    data
  })
  return response.data
}

export const avmSubmitReport = async(id: number, data: IAvmDataSubmit) : Promise<string> => {
  const payload = new FormData()
  payload.append('avmReportFile', data.avmReportFile)
  payload.append('orderId', `${id}`)
  payload.append('product', data.product)
  payload.append('fSD', data.fSD.toString())
  payload.append('value', data.value.toString())
  payload.append('highValue', data.highValue.toString())
  payload.append('lowValue', data.lowValue.toString())
  payload.append('confidence', data.confidence.toString())

  //  headers: { 'Content-Type': 'multipart/form-data' }
  const response = await request({
    url: BASE_ROUTE + `${id}/avm/submit-report`,
    method: 'post',
    data: payload
  })
  return response.data
  // request({
  //   url: BASE_ROUTE + `${id}/avm/submit-report`,
  //   method: 'post',
  //   data
  // })
}

export const deleteOrder = async(id: number, reason: string): Promise<string> => {
  const response = await request({
    url: BASE_ROUTE + `${id}/deactivate`,
    method: 'post',
    data: {
      reason,
      orderId: id
    }
  })
  return response.data
}

export const sendFixRequest = async(id: number, instructions: string, attachment: File): Promise<IOrderData> => {
  const payload = new FormData()
  payload.append('attachment', attachment)
  payload.append('orderId', `${id}`)
  payload.append('instructions', instructions)

  //  headers: { 'Content-Type': 'multipart/form-data' }
  const response = await request({
    url: FLOORPLAN_ROUTE + `${id}/fix-request`,
    method: 'post',
    data: payload
  })
  return response.data
}

export const addComment = (id: number, comment: string, forwardToIntegration: boolean) => {
  return request({
    url: BASE_ROUTE + `${id}/add-comment`,
    method: 'post',
    data: {
      comment,
      orderId: id,
      forwardToIntegration: forwardToIntegration
    }
  })
}

export const sendChangeStatus = (id: number, newStatus: string) => {
  return request({
    url: BASE_ROUTE + `${id}/change-status/${newStatus}`,
    method: 'post'
  })
}

export const addAppointmentDate = (id: number, date: Date, comment?: string) => {
  return request({
    url: BASE_ROUTE + `${id}/change-appointment`,
    method: 'post',
    data: {
      comment,
      AppointmentDate: date.toISOString(),
      orderId: id
    }
  })
}

export const getOrderCantFinishInspection = (id: number) =>
  request({
    url: DOCUMENT_ROUTE + `order/${id}/cantfinishinspection`,
    method: 'get',
    responseType: 'blob'
  })
